import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { cleanPageLocation, rememberAttribution, trackPageView } from '../../utils/googleAnalytics';

// Tells Google Analytics which app page is open, once per page. Rendered inside
// the router; renders nothing. Reports only the cleaned address, so a change
// that only touches something it strips (like ?email=) is not a new page.
const RouteAnalytics = () => {
  const location = useLocation();
  const lastSent = useRef('');

  useEffect(() => {
    const href = window.location.href;
    const page = cleanPageLocation(href);
    if (!page || page === lastSent.current) return;
    const referrer = lastSent.current || document.referrer;
    // The first app page this browser opens keeps its campaign tags for signup.
    if (!lastSent.current) rememberAttribution(href, document.referrer);
    lastSent.current = page;
    // Sent once the new page has rendered: pages set their own title in their
    // effects, which run after this one. Not cancelled on a quick move -- the
    // person did visit this page.
    setTimeout(() => trackPageView(href, document.title, referrer), 0);
  }, [location.pathname, location.search]);

  return null;
};

export default RouteAnalytics;
